/**
 * Checkout "Change" Button Click attributes for Amplitude.
 *
 * Event: `Button Click`
 * Shared properties:
 * - `component`: `button`
 * - `name` / `Name`: visible button label (`Change` in en-US)
 *
 * Distinguishing property: `Checkout Section`
 * - Restaurant → restaurant/location Change
 * - Payment Method → payment method Change
 * - Service Mode → pickup/service mode Change
 */
export const AMPLITUDE_CHECKOUT_SECTION_PROPERTY = 'Checkout Section';

export const AmplitudeCheckoutSection = {
  Restaurant: 'Restaurant',
  PaymentMethod: 'Payment Method',
  ServiceMode: 'Service Mode',
} as const;

export type AmplitudeCheckoutSectionValue = typeof AmplitudeCheckoutSection[keyof typeof AmplitudeCheckoutSection];

export type CheckoutChangeButtonEventAttributes = {
  [AMPLITUDE_CHECKOUT_SECTION_PROPERTY]: AmplitudeCheckoutSectionValue;
};

export const getCheckoutChangeButtonEventAttributes = (
  section: AmplitudeCheckoutSectionValue
): CheckoutChangeButtonEventAttributes => ({
  [AMPLITUDE_CHECKOUT_SECTION_PROPERTY]: section,
});
